import * as React from 'react';
import { IDropdownData } from 'models/common';
import { IStaticProps as ISelectProps } from '../PortalSelectMenu';
const classNames = require('classnames');

class PortalTileSelector<
	TValue = string,
	TKey extends string = string,
	TItem extends IDropdownData<TValue, TKey> = IDropdownData<TValue, TKey>,
> extends React.Component<ISelectProps<TValue, TKey, TItem>> {
	private get arrayValue(): TKey[] {
		const { value } = this.props.input;
		return value ? (Array.isArray(value) ? value : [value]) : [];
	}

	public render() {
		const { input, items, withImages, multi } = this.props;

		const handleClickOnTile = (key: TKey) => {
			if (multi) {
				const current = [...this.arrayValue];
				const currentIndex = current.indexOf(key);
				if (currentIndex === -1) {
					current.push(key);
				} else {
					current.splice(currentIndex, 1);
				}
				if (this.props.onChangeAction) {
					this.props.onChangeAction(current);
				}
				return input.onChange(current);
			}
			if (this.props.onChangeAction) {
				this.props.onChangeAction(key);
			}
			return input.onChange(key);
		};

		const displayActive = (key: TKey) => {
			if (multi) {
				return this.arrayValue.includes(key) ? 'active' : '';
			} else {
				return key === input.value ? 'active' : '';
			}
		};

		return (
			<div className="tileContainer">
				{(items || []).map((item) => (
					<div
						key={item.key}
						className={classNames('tile', displayActive(item.key), { itemDisabled: item.isDisabled })}
						onClick={() => !item.isDisabled && handleClickOnTile(item.key)}
					>
						{item?.image && withImages ? (
							<img alt="onboarding select item" src={require('containers/Html/images/onboarding/' + item?.image)} />
						) : null}
						{item?.description ? (
							<div className="twoPart">
								<p>{item.value}</p>
								<p>{item?.description}</p>
							</div>
						) : (
							item.value
						)}
					</div>
				))}
			</div>
		);
	}
}

export { PortalTileSelector };
